/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppVersionContentItemDto
 */
export interface AppVersionContentItemDto {
    /**
     * 
     * @type {string}
     * @memberof AppVersionContentItemDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof AppVersionContentItemDto
     */
    description: string;
}

/**
 * Check if a given object implements the AppVersionContentItemDto interface.
 */
export function instanceOfAppVersionContentItemDto(value: object): value is AppVersionContentItemDto {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function AppVersionContentItemDtoFromJSON(json: any): AppVersionContentItemDto {
    return AppVersionContentItemDtoFromJSONTyped(json, false);
}

export function AppVersionContentItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionContentItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
    };
}

export function AppVersionContentItemDtoToJSON(json: any): AppVersionContentItemDto {
    return AppVersionContentItemDtoToJSONTyped(json, false);
}

export function AppVersionContentItemDtoToJSONTyped(value?: AppVersionContentItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
    };
}

